import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useUser } from "../../context/UserContext";
import ExploreDropdown from "../DropdownMenus/ExploreDropdown";

const Nav = ({ isMobile = false }) => {
  const [activeMenuItem, setActiveMenuItem] = useState(null);
  const [mounted, setMounted] = useState(false);
  const router = useRouter();
  const { user } = useUser();

  const isMainDemo = router.pathname === "/home";
  const isActive = (href) => router.pathname === href;

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (router.pathname.includes("/announcements")) {
      setActiveMenuItem("announcements");
    } else if (router.pathname.includes("/jobs")) {
      setActiveMenuItem("jobs");
    } else if (router.pathname.includes("/course-list")) {
      setActiveMenuItem("courses");
    } else {
      setActiveMenuItem(null);
    }
  }, [router.pathname]);

  if (!mounted) return null;

  const handleAnnouncementsClick = (e) => {
    e.preventDefault();
    if (isMainDemo) {
      const el = document.getElementById("upcoming-events");
      if (el) el.scrollIntoView({ behavior: "smooth" });
      setActiveMenuItem("announcements");
    } else {
      router.push("/announcements");
    }
  };

  const handleJobsClick = (e) => {
    e.preventDefault();
    if (isMainDemo) {
      const el = document.getElementById("top-jobs");
      if (el) el.scrollIntoView({ behavior: "smooth" });
      setActiveMenuItem("jobs");
    } else {
      router.push("/jobs");
    }
  };

  const handleCoursesClick = (e) => {
    e.preventDefault();
    if (isMainDemo) {
      const el = document.getElementById("top-courses");
      if (el) el.scrollIntoView({ behavior: "smooth" });
      setActiveMenuItem("courses");
    } else {
      router.push("/course-list");
    }
  };

  return (
    <nav className="mainmenu-nav">
      <ul 
        className={`mainmenu ${isMobile ? '' : 'd-flex align-items-center gap-3'} mb-0`}
        style={isMobile ? { 
          display: 'flex', 
          flexDirection: 'column', 
          gap: '0', 
          padding: '20px 0',
          borderTop: '1px solid #e5e7eb',
          borderBottom: '1px solid #e5e7eb',
        } : {}}
      >
        {/* 🏠 Home */}
        <li className="nav-item" style={isMobile ? { width: '100%' } : {}}>
          <Link
            href="/home"
            className={`nav-link ${
              isActive("/home") ? "text-primary fw-bold" : ""
            }`}
            style={isMobile ? { 
              display: 'flex', 
              alignItems: 'center', 
              padding: '12px 0',
              fontSize: '15px',
              color: isActive("/home") ? '#2563eb' : 'inherit',
              textDecoration: 'none'
            } : {}}
          >
            🏠 Home
          </Link>
        </li>

        {/* 📅 Announcements */}
        <li className="nav-item" style={isMobile ? { width: '100%' } : {}}>
          <Link
            href="#"
            onClick={handleAnnouncementsClick}
            className={`nav-link ${
              activeMenuItem === "announcements" ? "text-primary fw-bold" : ""
            }`}
            style={isMobile ? { 
              display: 'flex', 
              alignItems: 'center', 
              padding: '12px 0',
              fontSize: '15px',
              color: activeMenuItem === "announcements" ? '#2563eb' : 'inherit',
              textDecoration: 'none'
            } : {}}
          >
            📅 Events
          </Link>
        </li>

        {/* 💼 Jobs */}
        <li className="nav-item" style={isMobile ? { width: '100%' } : {}}>
          <Link
            href="#"
            onClick={handleJobsClick}
            className={`nav-link ${
              activeMenuItem === "jobs" ? "text-primary fw-bold" : ""
            }`}
            style={isMobile ? { 
              display: 'flex', 
              alignItems: 'center', 
              padding: '12px 0',
              fontSize: '15px',
              color: activeMenuItem === "jobs" ? '#2563eb' : 'inherit',
              textDecoration: 'none'
            } : {}}
          >
            💼 Jobs
          </Link>
        </li>

        {/* 🎓 Courses */}
        <li className="nav-item" style={isMobile ? { width: '100%' } : {}}>
          <Link
            href="#"
            onClick={handleCoursesClick}
            className={`nav-link ${
              activeMenuItem === "courses" ? "text-primary fw-bold" : ""
            }`}
            style={isMobile ? { 
              display: 'flex', 
              alignItems: 'center', 
              padding: '12px 0',
              fontSize: '15px',
              color: activeMenuItem === "courses" ? '#2563eb' : 'inherit',
              textDecoration: 'none'
            } : {}}
          >
            🎓 Courses
          </Link>
        </li>
        
        <ExploreDropdown 
          activeMenuItem={activeMenuItem} 
          isActive={isActive} 
          isMobile={isMobile}
        />
      </ul>
    </nav>
  );
};

export default Nav;